import React from 'react';
import { Anchor, Box, Text, ResponsiveContext } from 'grommet';
import { Logo } from './Logo';
import { Github } from 'grommet-icons';

const NavHeader = () => (
  <ResponsiveContext.Consumer>
    {(size) => (
      <Box
        direction="row"
        justify="between"
        alignSelf="center"
        gap="medium"
        pad={{ top: 'large', horizontal: 'xlarge' }}
      >
        <Anchor
          href="/"
          icon={<Logo />}
          color="black"
          label={
            size !== 'xsmall' &&
            size !== 'small' && <Text size="large">AngulaRank</Text>
          }
        />
        <Box direction="row" gap="xxsmall" justify="center">
          <Anchor
            target="_blank"
            rel="noopener"
            href="https://github.com/angular"
            icon={<Github color="brand" size="large" />}
          />
        </Box>
      </Box>
    )}
  </ResponsiveContext.Consumer>
);

export { NavHeader };
